import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { X } from "lucide-react";
import { Box, IconButton } from "@mui/material";
import { IMAGE_MAP } from "./NetworkConstants";
const ImagePreviewModal = ({ activeImage, onClose }) => {
    if (!activeImage)
        return null;
    return (_jsx("div", { style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgb(0 0 0 / 55%)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }, onClick: (e) => {
            e.stopPropagation();
            onClose();
        }, children: _jsxs(Box, { sx: {
                position: "relative",
                backgroundColor: "white",
                borderRadius: "8px",
                padding: "20px",
                maxWidth: "90vw",
                maxHeight: "90vh"
            }, onClick: (e) => e.stopPropagation(), children: [_jsx(IconButton, { onClick: onClose, sx: {
                        position: "absolute",
                        top: -16,
                        right: -16,
                        bgcolor: "#f44336",
                        color: "white",
                        width: 36,
                        height: 36,
                        "&:hover": { bgcolor: "#d32f2f" }
                    }, children: _jsx(X, { size: 20 }) }), IMAGE_MAP[activeImage] && (_jsx("img", { src: IMAGE_MAP[activeImage], alt: "Instruction", style: {
                        maxWidth: "100%",
                        maxHeight: "calc(90vh - 40px)",
                        borderRadius: "8px"
                    } }))] }) }));
};
export default ImagePreviewModal;
